import { Pipe, PipeTransform } from '@angular/core';
import { PlCalendarEvent } from '@shared/services/lifemap/lifemap.service';
import { differenceInMinutes, getHours, getMinutes } from 'date-fns';

@Pipe({ name: 'eventShorterThan60MinOrStartsAt2330' })
export class EventShorterThan60MinOrStartsAt2330Pipe implements PipeTransform {
  public transform(event: PlCalendarEvent): boolean {
    if (event.end) {
      // We use 59 and not 60 here because events that finishes at 00:00 actually finishes at 23:59:59
      // if the event was finishing at 00:00, it will appear on the next day.
      // So this is a hack to go around this issue
      const eventShorterThan60min: boolean = differenceInMinutes(event.end, event.start) < 59;
      const eventStartsAt2330: boolean = getHours(event.start) === 23 && getMinutes(event.start) === 30;
      return eventShorterThan60min || eventStartsAt2330;
    }

    return false;
  }
}
@Pipe({ name: 'eventLongerThan60Min' })
export class EventLongerThan60MinPipe implements PipeTransform {
  public transform(event: PlCalendarEvent): boolean {
    if (event.end) {
      return differenceInMinutes(event.end, event.start) > 60;
    }

    return true;
  }
}
